import { UserRole } from 'src/backoffice-app-code/features/Auth/models/User';
import Iconify from 'src/components/Iconify';
import {
  EndUsersRoutes,
  AdminUsersRoutes,
  ProductMatchIndex,
  TransactionsRoutes,
  RetailersRoutes,
  DistributorsRoutes,
  PostsRoutes,
  CategoriesRoutes,
  TagRoutes,
  PagesRoutes,
  BannersRoutes,
  ContentEditorUsersRoutes,
  InsuranceAdminUsersRoutes,
  InsuranceAgentUsersRoutes,
  PlatformAdminUsersRoutes,
  ProductApprovalOperaterUsersRoutes,
  UnderwriterUsersRoutes,
  HomePagesRoutes,
  SpecificationAdminRoutes,
  UserManagementRoot,
  CodeBookIndex,
  ContractorsRoutes,
  ReportsRoutes,
  AgentRoot,
  AgentsRoutes,
  EnterProductNames,
  FiscalItemClaimsRoutes,
  FiscalBillsRoutes,
  BlackListRoutes,
  WhiteListIndex,
  InvoicesRoutes,
  PushNotificationsRoutes,
} from '../Routes';
import { ICONS } from './navIcons';

const adminNavConfigPrivate = [
  {
    subheader: 'general',
    items: [{ title: 'Home', path: HomePagesRoutes.platformAdminHomePage, icon: ICONS.dashboard }],
  },
  {
    subheader: 'Korisnici',
    items: [
      {
        title: 'Osiguranici',
        path: EndUsersRoutes.index,
        icon: ICONS.user,
      },
      {
        title: 'Savetnici',
        path: AgentRoot,
        icon: ICONS.user,
        roles: [UserRole.PlatformAdmin],
        children: [
          { title: 'Interni savetnici', path: AgentsRoutes.indexInternal },
          {
            title: 'Eksterni savetnici',
            path: AgentsRoutes.indexExternal,
          },
        ],
      },
      {
        title: 'Ugovarači',
        path: ContractorsRoutes.index,
        icon: ICONS.contractors,
      },
      {
        title: 'Ugovarači sa rizikom',
        path: ContractorsRoutes.indexRisk,
        icon: ICONS.contractors,
      },
      {
        title: 'Administratori',
        path: AdminUsersRoutes.index,
        icon: ICONS.lock,
      },
      {
        title: 'Kreiraj administratora',
        path: UserManagementRoot,
        icon: ICONS.label,
        roles: [UserRole.PlatformAdmin],
        children: [
          {
            title: 'Administrator platforme',
            path: PlatformAdminUsersRoutes.create,
          },
          {
            title: 'Savetnik osiguranja',
            path: InsuranceAgentUsersRoutes.create,
          },
          {
            title: 'Uderwriter',
            path: UnderwriterUsersRoutes.create,
          },
          {
            title: 'Operater osiguranja',
            path: InsuranceAdminUsersRoutes.create,
          },
          {
            title: 'Uređivač sadržaja',
            path: ContentEditorUsersRoutes.create,
          },
          {
            title: 'Operater proizvoda',
            path: ProductApprovalOperaterUsersRoutes.create,
          },
        ],
      },
      {
        title: 'Obaveštenja',
        path: PushNotificationsRoutes.root,
        icon: <Iconify icon={'ic:baseline-notifications'} />,
        roles: [UserRole.PlatformAdmin],
        children: [
          {
            title: 'Pošaljite obaveštenje',
            path: PushNotificationsRoutes.sendNotification,
          },
        ],
      },
    ],
  },
  {
    subheader: 'E-Fiscal',
    items: [
      // {
      //   title: 'Verifikacija proizvoda',
      //   path: ProductMatchIndex,
      //   icon: ICONS.verification,
      // },
      // {
      //   title: 'Unos naziva proizvoda',
      //   path: EnterProductNames,
      //   icon: ICONS.text,
      // },
      {
        title: 'Pretraga fiskalnih računa',
        path: FiscalBillsRoutes.index,
        icon: ICONS.search,
      },
      {
        title: 'Reklamacije',
        path: FiscalItemClaimsRoutes.index,
        icon: ICONS.claim,
      },
      // {
      //   title: 'Blacklist',
      //   path: BlackListRoutes.index,
      //   icon: ICONS.blackList,
      // },
      // {
      //   title: 'Whitelist',
      //   path: WhiteListIndex,
      //   icon: ICONS.whiteList,
      // },
      {
        title: 'Neispravni računi',
        path: InvoicesRoutes.indexWithErrors,
        icon: ICONS.blackList,
      },
    ],
  },
  {
    subheader: 'Transakcije',
    items: [
      {
        title: 'Transakcije',
        path: TransactionsRoutes.index,
        icon: ICONS.invoice,
      },
      {
        title: 'Specifikacije',
        path: SpecificationAdminRoutes.index,
        icon: ICONS.banking,
      },
    ],
  },
  {
    subheader: 'Partneri',
    items: [
      {
        title: 'Retaileri',
        path: RetailersRoutes.index,
        icon: ICONS.ecommerce,
      },
      {
        title: 'Distibuteri',
        path: DistributorsRoutes.index,
        icon: ICONS.booking,
      },
    ],
  },

  {
    subheader: 'CMS',
    items: [
      {
        title: 'Akcije',
        path: BannersRoutes.index,
        icon: ICONS.cart,
      },
      {
        title: 'Objave',
        path: PostsRoutes.index,
        icon: ICONS.blog,
      },
      {
        title: 'Kategorije',
        path: CategoriesRoutes.index,
        icon: ICONS.menuItem,
      },
      {
        title: 'Stranice',
        path: PagesRoutes.index,
        icon: <Iconify icon={'fluent:document-one-page-24-filled'} />,
      },
      {
        title: 'Tagovi',
        path: TagRoutes.index,
        icon: <Iconify icon={'ant-design:tags-outlined'} />,
      },
    ],
  },
  {
    subheader: 'Podešavanja',
    items: [
      {
        title: 'Šifarnici',
        path: CodeBookIndex,
        icon: ICONS.file,
      },
    ],
  },
  // {
  //   subheader: 'Izveštaji',
  //   items: [
  //     {
  //       title: 'Zaduženja agenata',
  //       path: ReportsRoutes.indexDailyPayments,
  //       icon: ICONS.invoice,
  //     },
  //   ],
  // },
];

export const adminNavConfig = [...adminNavConfigPrivate];
